import React from "react";
import axios from "./axios";
import store from "../reducers/createReducers";
import AuthenticationActions from "../actions/authentication-actions";
import {toast} from "react-toastify";
import CryptoJS from 'crypto-js';
import InformationToast from "../components/toast/InformationToast";
import sha256 from "crypto-js/sha256";

// const BASE_ASSOCIATE_URL = "http://127.0.0.1:8888/client/";
// export const BASE_URL = "http://127.0.0.1:8888/";

// export const BASE_URL = "https://services.stilsys.net/api/player/";
const secretKey = 'YrghYpqEjudJHBcqEvYxMNcuxvnfUj';


const generateHmacSignature = (payload) => {
    // Convert the payload to a string (assuming it's an object)
    const payloadString = JSON.stringify(payload);

    // Create HMAC signature using SHA-256 and secretKey
    return CryptoJS.HmacSHA256(payloadString, secretKey).toString(CryptoJS.enc.Hex);
};


const generateFingerprint = () => {
    // eslint-disable-next-line no-restricted-globals
    const raw = `${navigator.userAgent}|${screen.width}x${screen.height}|${navigator.language}`;
    return sha256(raw).toString();
};

class AssociateServices extends React.Component {

    handle = async (endpoint, instance, heads = {}) => {
        // if (res?.errors)
        //     toast.error(res?.errors)

        const newInstance = {
            ...instance,
            rt: parseInt(Date.now() / 1000)
        };
        const response = await axios.post(endpoint, newInstance, {
            ...heads,
            'X-SIGNATURE': generateHmacSignature(newInstance),
            'X-Fingerprint': generateFingerprint()
        })

        if (response?.status === 401) {
            store.dispatch(AuthenticationActions.setUserLogOut(null))
            localStorage.clear()
        }


        if (response?.status === 308) {
            store.dispatch(AuthenticationActions.navigateToHomepage(true))
        }


        if (response?.message === "Too Many Requests") {
            toast(<InformationToast
                icon={'ti-x'}
                message={"--"}
                title={"Too Many Attempts."}
            />)
        }

        return response;
    }
    handleGet = async (endpoint) => {
        console.log('endpoint = ', endpoint)
        return await axios.get(endpoint)
    }

    checkLocation = (instance) => this.handle("public/location/check", instance, {'X-Domain': instance.domain});

    user = (instance) => this.handle("user", instance);
    checkStream = (instance) => this.handle("stream/permission", instance);
    pingStream = (instance) => this.handle(`stream/ping/${instance.name}`, instance);
    killStream = (instance) => this.handle(`stream/kill/${instance.name}`, instance);
    joinStream = (instance) => this.handle(`public/stream/join/${instance.id}`, instance);
    logout = (instance) => this.handle("user/logout", instance);
    setLanguage = (instance) => this.handle("user/language", instance);
    profile = (instance) => this.handle("profile", instance);
    updateProfile = (instance) => this.handle("profile/update", instance);
    updateUsername = (instance) => this.handle("user/username", instance);

    getSessions = (instance) => this.handle("sessions", instance);
    checkSelfExclusion = (instance) => this.handle("self-exclusion/check", instance);
    activateSelfExclusion = (instance) => this.handle("self-exclusion/activate", instance);
    deleteSelfExclusion = (instance) => this.handle("self-exclusion/delete", instance);
    deactivateSession = (instance) => this.handle(`sessions/deactivate/${instance.id}`, instance);
    changePass = (instance) => this.handle("user/change-password", instance);
    getAuthenticatorLink = (instance) => this.handle("user/get-authenticator", instance);
    getOtpStep = (instance) => this.handle("user/get-otp-step", instance);
    setOtpStep = (instance) => this.handle("user/set-otp-step", instance);
    setAffiliate = (instance) => this.handle("user/affiliate", instance);
    setAuthenticator = (instance) => this.handle("user/enable-authenticator", instance);
    loginOtpVerify = (instance) => this.handle("public/otp/verify", instance);

    sendMailToVerify = (instance) => this.handle("user/send-email", instance);
    register = (instance) => this.handle("auth/register", instance);
    getAuthSettings = (instance) => this.handle("auth/auth-settings", instance);
    authGoogle = (instance) => this.handle("auth/google", instance);
    authTelegram = (instance) => this.handle("auth/telegram", instance);
    authConversion = (instance) => this.handle("auth/conversion", instance);
    completeAuthConversion = (instance) => this.handle("auth/conversion/complete", instance);
    verifyRegistration = (instance) => this.handle("auth/verify", instance);
    login = (instance) => this.handle("auth/login", instance);
    forgotPassword = (instance) => this.handle("auth/forgot-password", instance);
    forgotPasswordOtp = (instance) => this.handle("auth/forgot-password/otp", instance);
    forgotPasswordPassword = (instance) => this.handle("auth/forgot-password/pass", instance);

    getWallets = (instance) => this.handle("wallet/index", instance);
    getVaults = (instance) => this.handle("vaults/index", instance);
    getNetworkSettings = (instance) => this.handle("networks/settings", instance);

    getModalImage = (instance) => this.handle("networks/settings", instance);
    getIgnoredUsers = (instance) => this.handle(`ignored-users/index/${instance.page}/${instance.limit}`, instance);
    ignore = (instance) => this.handle("ignored-users/ignore", instance);
    unignore = (instance) => this.handle("ignored-users/cancel", instance);
    checkWalletDiscount = (instance) => this.handle("wallet/discount/check", instance);

    getBonusRequestContent = (instance) => this.handle("bonus-request-contents/index", instance);
    claimBonusRequestContent = (instance) => this.handle(`bonus-request-contents/claim/${instance.id}`, instance);

    claimWalletDiscount = (instance) => this.handle("wallet/discount/claim", instance);

    getWalletDiscountAmount = (instance) => this.handle("wallet/discount/amount", instance);
    createWallet = (instance) => this.handle("wallet/create", instance);
    getCurrencies = (instance) => this.handle("public/wallet/currencies", instance);

    getGameProviders = (instance) => this.handle("public/providers/index", instance);
    getChatMessageRules = (instance) => this.handle("public/chat/rules", instance);
    getPolicies = (instance) => this.handle("public/policies/index", instance);
    getSidebarGameGroups = (instance) => this.handle("public/games/group/sidebar", instance);
    getHomepageGameGroups = (instance) => this.handle("public/games/group/homepage", instance);
    getCasinoLobbyGameGroups = (instance) => this.handle("public/games/group/casino", instance);
    getSlotLobbyGameGroups = (instance) => this.handle("public/games/group/slot", instance);
    getLiveLobbyGameGroups = (instance) => this.handle("public/games/group/live", instance);
    getPromotionList = (instance) => this.handle("public/promotions/index", instance);
    getBlogList = (instance) => this.handle("public/blogs/index", instance);
    getWheelTypes = (instance) => this.handle("public/wheel/types", instance);
    getWheelLatestSpins = (instance) => this.handle("public/wheel/latest", instance);
    getWheelPrizeDetail = (instance) => this.handle(`public/wheel/prize/${instance.id}`, instance);
    getWheelPrizeClaim = (instance) => this.handle(`wheel/claim/${instance.id}`, instance);
    getWheelTickets = (instance) => this.handle("wheel/tickets", instance);
    spinWheel = (instance) => this.handle("wheel/spin", instance);
    getBlogListTop = (instance) => this.handle("public/blogs/top", instance);
    getBlogsByCategory = (instance) => this.handle("public/blogs/category", instance);
    getPromotionsByCategory = (instance) => this.handle("public/promotions/category", instance);
    getBlogCategories = (instance) => this.handle("public/blog-categories/index", instance);
    getPromotionCategories = (instance) => this.handle("public/promotion-categories/index", instance);
    getStreamList = (instance) => this.handle(`public/stream/index/${instance.page}/${instance.limit}`, instance);
    showPromotion = (instance) => this.handle(`public/promotions/show/${instance.slug}`, instance);
    showBlog = (instance) => this.handle(`public/blogs/show/${instance.slug}`, instance);
    makeCallRequest = (instance) => this.handle(`call-requests/store`, instance);
    getScripts = (instance) => this.handle("public/scripts/index", instance);
    checkModal = (instance) => this.handle("public/modals/get", instance);
    ignoreModal = (instance) => this.handle(`modals/ignore/${instance.id}`, instance);
    showPolicy = (instance) => this.handle(`public/policies/show/${instance.path}`, instance);
    getGameProvidersGroup = (instance) => this.handle(`public/providers/group/${instance.type}`, instance);
    getNetworks = (instance) => this.handle("public/networks", instance);


    getCategoryGames = (instance) => this.handle("public/games2/index", instance);

    getFilteredGames = (instance) => this.handle(`public/games2/index/${instance.filter}`, instance);
    getCasinoGroupGames = (instance) => this.handle(`public/games2/group/${instance.type}`, instance);
    getCasinoCategoryGames = (instance) => this.handle(`public/games2/category/${instance.type}`, instance);
    getProviderGames = (instance) => this.handle(`public/games2/provider/${instance.id}`, instance);
    getSliderGames = (instance) => this.handle(`public/games2/slider`, instance);
    getGamesByTag = (instance) => this.handle(`public/games/category/${instance.external_id}/${instance.page}/${instance.limit}`, instance);
    getDebits = (instance) => this.handle(`public/debits/index/${instance.type}/${instance.page}/${instance.limit}`, instance);
    getCasinoTableDebits = (instance) => this.handle(`public/debits/casino/${instance.limit}/${instance.type}`, instance);
    getMyDebits = (instance) => this.handle(`my-debits/${instance.type}/${instance.page}/${instance.limit}`, instance);
    getCasinoGameDebits = (instance) => this.handle(`public/debits/casino/game/${instance.game_id}/${instance.limit}/${instance.type}`, instance);
    getSportsTableDebits = (instance) => this.handle(`public/debits/sportsbook/${instance.limit}/${instance.type}`, instance);
    getSportsbookDebits = (instance) => this.handle(`public/debits/sportsbook/${instance.page}/${instance.limit}`, instance);
    getTradeDebits = (instance) => this.handle(`public/debits/trade/${instance.page}/${instance.limit}`, instance);
    getDebitReference = (instance) => this.handle(`public/debits/reference/${instance.reference}`, instance);
    getSportsbookDebitReference = (instance) => this.handle(`public/debits/sportsbook/${instance.reference}`, instance);
    getTipDetail = (instance) => this.handle(`tips/detail/${instance.id}`, instance);
    getTips = (instance) => this.handle(`tips/list/${instance.page}/${instance.limit}`, instance);
    getTransactions = (instance) => this.handle(`transactions/index/${instance.type}/${instance.page}/${instance.limit}`, instance);
    getSliders = (instance) => this.handle(`public/sliders/index`, instance);
    getChallenges = (instance) => this.handle(`public/challenges/index`, instance);
    getMiniBanners = (instance) => this.handle(`public/mini-banners/index`, instance);
    getMiniSliders = (instance) => this.handle(`public/mini-sliders/index`, instance);
    withdraw = (instance) => this.handle(`transactions/withdraw`, instance);
    getPaymentMethods = (instance) => this.handle(`payment/methods`, instance);
    getPaymentProviders = (instance) => this.handle(`payment/providers`, instance);
    getPaymentProvidersAll = (instance) => this.handle(`payment/providers-all`, instance);
    depositVault = (instance) => this.handle(`vaults/deposit`, instance);
    withdrawVault = (instance) => this.handle(`vaults/withdrawal`, instance);
    getMinWithdrawAmount = (instance) => this.handle(`transactions/conversion`, instance);
    getTransferBankList = (instance) => this.handle(`transactions/bank-list`, instance);

    getTransferBankInfo = (instance) => this.handle(`transactions/bank-info`, instance);
    buyCrypto = (instance) => this.handle(`transactions/buy-crypto`, instance);
    getRakebacksList = (instance) => this.handle(`rakebacks/list/${instance.page}/${instance.limit}`, instance);

    getDiscountList = (instance) => this.handle(`wallet/discount/index/${instance.page}/${instance.limit}`, instance);

    getCorrectionList = (instance) => this.handle(`corrections/index/${instance.page}/${instance.limit}`, instance);

    getCountryList = (instance) => this.handle(`public/countries`, instance);
    clickCampaign = (instance) => this.handle(`public/campaigns/click`, instance);
    getPromotions = (instance) => this.handle(`public/promotions`, instance);
    // getConfiguration = (instance) => this.handle(`public/configuration`, instance);
    getCookie = (instance) => this.handle(`public/configuration/cookie`, instance);
    getConfiguration = (instance) => this.handle(`public/configuration`, instance);
    getCssFiles = (instance) => this.handle(`public/css/index`, instance);

    getDebitsOfGame = (instance) => this.handle(`public/debits/by-game/${instance.game_id}/${instance.type}/${instance.limit}`, instance);
    getBigWins = (instance) => this.handle(`public/debits/big-wins`, instance);
    getFavorites = (instance) => this.handle("games2/favorites", instance);
    searchGames = (instance) => this.handle(`public/games2/search`, instance);
    playGame = (instance) => this.handle(`public/games2/play-game/${instance.slug}`, instance);
    playPoker = (instance) => this.handle(`games2/poker`, instance);

    favoriteGame = (instance) => this.handle(`games2/favorite/${instance.game_id}`, instance);


    // todo documents routes
    uploadDocument = (instance) => this.handle("documents/upload", instance);


    // BONUS DROPS
    redeemBonus = (instance) => this.handle("bonus-drops/redeem", instance);
    redeemWelcomeBonus = (instance) => this.handle("welcome-bonuses/redeem", instance);

    getGameURL = (instance) => this.handle(`public/games2/get-url`, instance);
    getTradeUrl = (instance) => this.handle(`public/games2/trade`, instance);
    getSportsBookURL = (instance) => this.handle(`public/games2/sportsbook`, instance);
    getESportURL = (instance) => this.handle(`public/games2/e-sport`, instance);

    getAvailableReloads = (instance) => this.handle("reloads", instance);
    checkCorrection = (instance) => this.handle("corrections/check", instance);
    checkUserHasActiveBonus = (instance) => this.handle("bonuses/check", instance);
    getBonusDetail = (instance) => this.handle(`bonuses/show/${instance.id}`, instance);
    getBonuses = (instance) => this.handle(`bonuses/index/${instance.page}/${instance.limit}`, instance);
    cancelBonus = (instance) => this.handle(`bonuses/cancel/${instance.id}`, instance);
    getSwapResults = (instance) => this.handle(`swaps/calculate`, instance);
    getReloadHistory = (instance) => this.handle(`reloads/list/${instance.page}/${instance.limit}`, instance);
    checkAvailableReload = (id) => this.handle("reloads/check/" + id, {});
    reload = (instance) => this.handle("reloads/claim", instance);

    // CORE SERVICES
    getRakebacks = (instance) => this.handle("rakebacks", instance);
    rakeback = (instance) => this.handle("rakebacks/rakeback", instance);
    tip = (instance) => this.handle("tips/tip", instance);
    calculateUnifyBalances = (instance) => this.handle("unify-balances/calculate", instance);
    unifyBalances = (instance) => this.handle("unify-balances/unify", instance);

    rain = (instance) => this.handle("tips/rain", instance);
    getNotifications = (instance) => this.handle("notifications", instance);
    getMessages = (instance) => this.handle("messages", instance);
    checkNotifications = (instance) => this.handle("notifications/check", instance);
    checkMessages = (instance) => this.handle("messages/check", instance);
    markNotifications = (instance) => this.handle("notifications/mark", instance);
    markMessages = (instance) => this.handle("messages/mark", instance);


    getAvailableBoost = (instance) => this.handle("boosts", instance);
    getVipState = (instance) => this.handle(`public/vip/state/${instance.username}`, instance);
    getVipStates = (instance) => this.handle(`public/vip/states`, instance);

    getRaffles = (instance) => this.handle(`public/raffles/${instance.username}/${instance.page}/${instance.limit}`, instance);
    getTournaments = (instance) => this.handle(`public/tournaments/index/${instance.page}/${instance.limit}`, instance);
    getTournamentLeaderboard = (instance) => this.handle(`public/tournaments/leaderboard/${instance.uuid}`, instance);
    showTournament = (instance) => this.handle(`public/tournaments/show/${instance.uuid}`, instance);
    getActiveRaces = (instance) => this.handle(`public/races/${instance.username}`, instance);
    getRaceDetail = (instance) => this.handle(`public/races/check/${instance.uuid}`, instance);
    getRaffleDetail = (instance) => this.handle(`public/raffles/check/${instance.uuid}`, instance);
    getRaceHistory = (instance) => this.handle(`public/races/history/${instance.username}/${instance.page}/${instance.limit}`, instance);
    getBasicStats = (username, type, currency) => this.handle(`public/stats/basic/${username}/${type}/${currency}`, {});
    requestDownload = (instance) => this.handle(`downloads/request`, instance);
    getRaffleTickets = (type) => this.handle(`raffles/${type}/tickets`, {});
    getCampaigns = (instance) => this.handle(`campaigns/index/${instance.page}/${instance.limit}`, instance);
    storeCampaign = (instance) => this.handle(`campaigns/store`, instance);
    verifyPhone = (instance) => this.handle(`phones/verify`, instance);
    checkPhone = (instance) => this.handle(`phones/check`, instance);
    getReferredUsers = (instance) => this.handle(`campaigns/users/${instance.page}/${instance.limit}`, instance);
    getCampaignsFunds = (instance) => this.handle(`campaigns/funds`, instance);
    claimCampaignsFunds = (instance) => this.handle(`campaigns/claim`, instance);
    getBetRadarDetail = (url) => this.handleGet(url);

    getDashboardSlideGames = (instance) => this.handle(`public/games2/welcome/${instance.type}`, instance);

    getMiniGames = (instance) => this.handle(`public/games2/mini`, instance);
    checkEmail = (instance) => this.handle(`public/email-verification/check`, instance);
    getFaqs = (instance) => this.handle(`public/faq/index`, instance);

}


const associateServices = new AssociateServices();
export default associateServices;
